import { 
  TablePage,
  AddPage,
  EditPage,
  ViewPage, 
} from 'src/views/edi/partymapping'

import pathMap from 'src/paths/PathMap_EDI'

class PartyMappingRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.PARTY_MAPPING_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.PARTY_MAPPING_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.PARTY_MAPPING_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.PARTY_MAPPING_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}
export default PartyMappingRoute